// useDropboxImages.js
import { useEffect, useState, useCallback } from "react";
import { api } from "./pureFunctions";
import { header } from "./globalVariables";

const PAGE_SIZE = 9;

export function useDropboxImages(folder, subfolder) {
   const [allImages, setAllImages] = useState([]); // full list, no thumbnails yet
   const [loadedImages, setLoadedImages] = useState([]); // images with thumbnails attached
   const [loadingList, setLoadingList] = useState(true);
   const [loadingMore, setLoadingMore] = useState(false);
   const [error, setError] = useState(null);

   // Step 1: fetch the full list of image paths once
   useEffect(() => {
      if (!folder || !subfolder) return;
      setLoadingList(true);

      api(
         `/api/dropbox/folder-images/list?folder=${encodeURIComponent(folder)}&subfolder=${encodeURIComponent(subfolder)}`,
      )
         .then((data) => {
            console.log(data);

            setAllImages(data?.data?.images ?? []);
         })
         .catch(setError)
         .finally(() => setLoadingList(false));
   }, [folder, subfolder]);

   // Step 2: load thumbnails for the next page
   const loadMore = useCallback(async () => {
      const nextBatch = allImages.slice(loadedImages.length, loadedImages.length + PAGE_SIZE);
      if (nextBatch.length === 0) return;
      console.log(nextBatch);

      setLoadingMore(true);
      try {
         const data = await api.post(
            "/api/dropbox/folder-images/thumbnails",
            {
               paths: nextBatch.map((img) => img.path),
            },
            header,
         );
         console.log(data);

         const enriched = nextBatch.map((img) => ({
            ...img,
            thumbnail: data?.data?.thumbnails[img.path] || null,
         }));
         console.log(enriched);

         setLoadedImages((prev) => [...prev, ...enriched]);
      } catch (err) {
         setError(err);
      } finally {
         setLoadingMore(false);
      }
   }, [allImages, loadedImages]);

   // Auto-load first page once the list arrives
   useEffect(() => {
      if (allImages.length > 0 && loadedImages.length === 0) {
         loadMore();
      }
   }, [allImages]); // eslint-disable-line react-hooks/exhaustive-deps

   console.log(loadedImages);
   console.log(allImages);

   const hasMore = loadedImages.length < allImages.length;

   return { loadedImages,setLoadedImages, hasMore, loadingList, loadingMore, loadMore, error };
}
